import orderBy from "lodash/orderBy"
import get from "lodash/get"
import { Sort } from "../factory/types"

const normalize = (v: any) =>
  typeof v === "string"
    ? v
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, "")
        .toLowerCase()
    : v

const extract = (item: any, key?: string | null) => normalize(key ? get(item, key) : undefined)
const isMissing = (value: any) => value === null || value === undefined

export function sortItems<T>(list: T[], sort: Sort | null): T[] {
  if (!sort?.key) return list

  return orderBy(
    list,
    [
      (i) => isMissing(extract(i, sort.key)),
      (i) => extract(i, sort.key),
      (i) => isMissing(extract(i, sort.keySecondary)),
      (i) => extract(i, sort.keySecondary),
      "id"
    ],
    [
      "asc",
      sort.asc ? "asc" : "desc",
      "asc",
      sort.keySecondary ? (sort.ascSecondary ? "asc" : "desc") : "asc",
      "asc"
    ]
  )
}
